import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var VideoSquareIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 24 24",
                    children: [
                        _jsxs("g", {
                            clipPath: "url(#video-square__a)",
                            children: [
                                _jsx("path", {
                                    d: "M20.765 23.35H3.245c-.69 0-1.34-.27-1.83-.76-.48-.48-.76-1.15-.76-1.83V3.24c0-.69.27-1.34.76-1.83s1.14-.76 1.83-.76h17.51c.69 0 1.34.27 1.83.76s.76 1.14.76 1.83v17.51c0 .68-.28 1.35-.76 1.83-.49.49-1.14.76-1.83.76l.01.01zM3.245 2.65a.59.59 0 00-.42.17.59.59 0 00-.17.42v17.51c0 .16.06.31.17.42.11.11.26.17.42.17h17.51c.16 0 .31-.06.42-.17a.59.59 0 00.17-.42V3.24a.59.59 0 00-.17-.42.59.59 0 00-.42-.17H3.245z"
                                }),
                                _jsx("path", {
                                    d: "M13.725 16.86h-6.43c-.24 0-.48-.05-.71-.14-.23-.09-.43-.23-.6-.4-.18-.18-.31-.38-.4-.6-.09-.23-.14-.47-.14-.71v-6c0-.5.19-.96.54-1.31.35-.35.81-.54 1.31-.54h6.43c.5 0 .96.2 1.31.55.29.29.47.66.53 1.07l1.03-.46s.02 0 .03-.01c.22-.09.46-.12.7-.09.24.03.46.11.64.25.19.14.35.31.45.52.1.2.16.43.16.66v4.77c0 .23-.06.46-.16.66-.11.21-.27.39-.46.52-.2.13-.41.22-.64.24-.24.03-.47 0-.68-.08l-1.08-.48c-.05.4-.23.78-.53 1.07-.35.35-.82.55-1.32.55l.02-.04zm-6.29-2h6.15v-1.14c0-.34.17-.65.46-.84.28-.18.64-.21.95-.08l1.6.71v-3.02l-1.6.71c-.31.14-.67.11-.95-.08a1 1 0 01-.45-.84V9.14h-6.15v5.72h-.01z"
                                })
                            ]
                        }),
                        _jsx("defs", {
                            children: _jsx("clipPath", {
                                id: "video-square__a",
                                children: _jsx("path", {
                                    d: "M0 0h24v24H0z"
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
VideoSquareIcon.isCarinaIcon = true;
export default VideoSquareIcon;
